module.exports = __webpack_public_path__ + "static/media/iphone_14_midnight_plus.88978b17.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_midnight_plus.jpeg
// module id = 2126
// module chunks = 0